import { AccountInfo } from '@azure/msal-browser'
import { createContext } from "react"

interface IAuthenticationContext {
	accountInfo: null | AccountInfo
}

export const AuthenticationContext = createContext<IAuthenticationContext>({
	accountInfo: null,
})
